import AnimatedTreeIcon from "./AnimatedTreeIcon";
import "./mindGameBrand.css";
import "./dashboardLoader.css";

export default function DashboardLoader({ label }) {
  return <div className="tt-brand-loader" role="status" aria-label={`Loading ${label} rankings`}>
    <div className="tt-brand-loader-icon"><AnimatedTreeIcon colorRing /></div>
    <span className="tt-brand-loader-caption">Loading {label}</span>
  </div>;
}

export function DashboardContent({ loading, label, children }) {
  return loading ? <DashboardLoader label={label} />
    : <div className="mg-dashboard-content">{children}</div>;
}
